module.exports = __webpack_public_path__ + "img/vehicle-solutions-logo-type2.4f1bf613.png";